module.exports = __webpack_public_path__ + "img/index-banner1.0e660b5d.jpg";